import { ReservationTimeState, ServiceOrderState } from '@mews-commander/data-access';
import { getCurrentCompanionAccommodationExtent } from '@mews-commander/legacy-entities/src/selectors/reservations';
import { ReservationOptions } from '@mews-commander/types';
import {
    getTagVariantFromReservationTimeState,
    getTextKeyFromServiceOrderState,
    useCommanderSelector,
} from '@mews-commander/utils';
import { EnumValue } from '@mews/enumify';
import { LocalizedText } from '@mews/framework';
import { Tag } from '@optimus-web/core';

interface ReservationStateTagProps {
    state: EnumValue<ServiceOrderState, number> | undefined;
    options: ReservationOptions;
    timeState: EnumValue<ReservationTimeState, number> | undefined;
}

export const ReservationStateTag: React.FC<ReservationStateTagProps> = ({ timeState, options, state }) => {
    const companionExtent = useCommanderSelector((s) =>
        getCurrentCompanionAccommodationExtent(s, { timeState, options, state })
    );

    const variant = getTagVariantFromReservationTimeState(timeState?.value, { companionExtent, ...options });

    const textKey =
        state && timeState && getTextKeyFromServiceOrderState(state.name, timeState.name, companionExtent, options);

    if (!textKey) {
        return null;
    }

    return (
        <Tag variant={variant}>
            <LocalizedText textKey={textKey} data-test-id="reservationStateTag" />
        </Tag>
    );
};
